<template>
  <main>
    <div class="container">
      <div class="row justify-content-center mb-4">
        <div class="col-12 col-lg-8">
          <h1 class="text-center">Benutzeranmeldung</h1>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-12 col-lg-8">
          <div class="alert alert-danger" v-if="errorMessage" role="alert">
            {{ errorMessage }}
          </div>
          <form @submit.prevent="checkUser">
            <div class="mb-4">
              <label for="user" class="form-label">Benutzername</label>
              <input type="text" class="form-control" v-model="user" id="user" placeholder="Benutzername">
            </div>
            <div class="mb-4">
              <label for="password" class="form-label">Passwort</label>
              <input type="password" class="form-control" v-model="password" id="password" placeholder="Passwort">
            </div>
            <div class="d-flex justify-content-center mb-5">
              <button type="submit" class="btn btn-primary">Einloggen</button>
            </div>
          </form>
          <div v-if="responseData" class="alert alert-info mt-3">
            <strong>Server-Antwort:</strong> {{ responseData }}
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import {ref, defineComponent} from "vue";
import axios from "axios";
import {useRouter} from "vue-router";

export default defineComponent({
  setup(props, {emit}) {
    const router = useRouter();
    const user = ref("");
    const password = ref("");
    const errorMessage = ref("");
    const userData = ref([]);

    const checkUser = async () => {
      errorMessage.value = "";
      localStorage.removeItem("userCheckResult");
      try {
        userData.value = {
          "user": user.value,
          "password": password.value
        }
        const response = await axios.post('http://localhost:8082/gemeinde/checkUser', userData.value);
        localStorage.setItem("userCheckResult", JSON.stringify(response.data));
        emit('isLoggedIn', true);
        router.push({name: 'home'});
      } catch (error) {
        errorMessage.value = "Login fehlgeschlagen. Bitte prüfen Sie Ihre E-Mail-Adresse und Passwort."
        console.error("Error fetching data:", error);
      }
    }

    return {
      user,
      password,
      errorMessage,
      checkUser
    };
  }
});
</script>

<style scoped>
/* Optional: CSS für Styling */
.alert {
  text-align: center;
}
</style>
